import { types } from 'mobx-state-tree'

import { Activity } from './Activity'
import { BookingActivity } from './BookingActivity'
import { BookingRequestActivity } from './BookingRequestActivity'
import { CompanyUserActivity } from './CompanyUserActivity'
import { CustomsDecisionUpdateActivity } from './CustomsDecisionUpdateActivity'
import { CustomsStatusUpdateActivity } from './CustomsStatusUpdateActivity'
import { DocumentUploadActivity } from './DocumentUploadActivity'
import { ManualQuoteActivity } from './ManualQuoteActivity'
import { MessageActivity } from './MessageActivity'
import { ProductUpdateActivity } from './ProductUpdateActivity'
import { ShipmentUpdateActivity } from './ShipmentUpdateActivity'
import { SubscriptionActivity } from './SubscriptionActivity'
import { TransportPlanUpdatedActivity } from './TransportPlanUpdatedActivity'

export const BaseActivity = types.union(
  (snapshot) => {
    switch (snapshot.type) {
      case 'booking':
        return BookingActivity
      case 'documentUpload':
        return DocumentUploadActivity
      case 'message':
        return MessageActivity
      case 'shipmentUpdate':
        return ShipmentUpdateActivity
      case 'subscription':
        return SubscriptionActivity
      case 'companyUserUpdate':
        return CompanyUserActivity
      case 'transportPlanUpdated':
        return TransportPlanUpdatedActivity
      case 'manualQuote':
        return ManualQuoteActivity
      case 'customsDecisionUpdate':
        return CustomsDecisionUpdateActivity
      case 'customsStatusUpdate':
        return CustomsStatusUpdateActivity
      case 'productUpdate':
        return ProductUpdateActivity
      case 'bookingRequest':
        return BookingRequestActivity
      default:
        return Activity
    }
  },
  BookingActivity,
  DocumentUploadActivity,
  MessageActivity,
  CompanyUserActivity,
  TransportPlanUpdatedActivity,
  ManualQuoteActivity,
  ProductUpdateActivity,
  Activity
)

export type TBaseActivity = typeof BaseActivity.Type
